import React from 'react'
import bountybanner from '../../assets/BugBountyImages/bountybanner.png'

const BountyBanner = () => {
  return (
      <div>
          <div class="container p-0 mt-0 mt-md-5 position-relative">
    <img className='col-12 rounded-0 rounded-md-top-2 animate-fade ' src={bountybanner}></img>
    <div class="position-md-absolute position-relative left-0 d-flex align-items-center top-0 w-100 h-100">
        <div class="container px-md-5 px-0">
            <div class="bg-dark rounded-top-0 rounded-md-2 w-fit rounded animate-fade p-3">

                <h1 className='text-white'>Turn Bugs Into Bounties</h1>
                <p>Transform Vulnerabilities into Victory—Turn Bugs into Bounties! with our dedicated bug bounty lab.
                </p>
            </div>
        </div>
    </div>

</div>
      
    </div>
  )
}

export default BountyBanner
